var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMonsterLikeBatIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5577 5.40723C25.5577 5.40723 29.1133 7.7776 26.7429 13.7035L26.7421 13.7035C26.7421 15.2729 25.9794 16.6641 24.8046 17.5269C27.5171 18.7225 36.0893 19.0739 34.9835 11.3332C34.8152 10.1598 36.1687 10.148 37.3539 11.3332C40.9094 14.8887 44.465 20.6179 42.0946 35.0369C38.539 29.1109 34.9835 30.2961 33.7983 36.222C30.5259 31.8588 27.2534 33.5193 24.905 35.6594C23.9367 36.8054 22.8872 37.4074 22.0027 37.4074C21.1661 37.4074 20.1818 36.8688 19.2584 35.8409C16.8981 33.6174 13.5337 31.7361 10.1693 36.222C8.98408 30.2961 5.42853 29.1109 1.87297 35.0369C-0.4974 20.6179 3.05816 14.8887 6.61371 11.3332C7.7989 10.148 9.15238 10.1598 8.98408 11.3332C7.87526 19.0949 16.4971 18.7205 19.185 17.5171C18.0176 16.6536 17.2607 15.267 17.2606 13.7035L17.2594 13.7035C14.889 7.7776 18.4445 5.40723 18.4445 5.40723C18.4445 5.40723 20.3551 6.36249 20.7457 9.13063C21.1456 9.02105 21.5667 8.96254 22.0014 8.96254C22.4359 8.96254 22.8568 9.02101 23.2566 9.1305C23.6472 6.36246 25.5577 5.40723 25.5577 5.40723Z",
    fill: "url(#paint0_linear_6624_72834)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6624_72834",
    x1: 30.056,
    y1: 16.2671,
    x2: 30.056,
    y2: 34.2274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8F00FF",
    stopOpacity: 0.6
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonsterLikeBatIcon);
export default __webpack_public_path__ + "static/media/monster-like-bat-icon.6a5cd36e6e6fc672b5ced92fb5e4d619.svg";
export { ForwardRef as ReactComponent };